/**
 * Indicates where the user has come from, usually found in the query params.
 */
export enum Origin {
    Crosswordle = "crosswordle",
    None = "none"
}